/**
 * @desc 平台账期相关-查询当前账期
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/fulfilment/platformAccountPeriod/currentPeriod`, {
      method: "GET",

      ...options,
    }),
  );
}
